module.exports = __webpack_public_path__ + "img/STANDARDCHARTERED.f630a0fb.svg";